/** The tags brain's Escape handlers treat as a field that keeps its Escape (`SkillDetailView.tsx:94-96`). */
const FIELD_TAGS: ReadonlySet<string> = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

/** Ported from Clarity `apps/web/src/features/systemDomain/components/SkillDetailView.tsx` + `apps/web/src/features/systemDomain/components/orgDetail/UserActivityFlyIn.tsx` (commit `f9217bb5a`). */
/**
 * Whether an `INPUT`, `TEXTAREA` or `SELECT` has focus — the one condition under which brain's
 * content-level Escape handlers leave the key alone (`SkillDetailView.tsx:94-96`,
 * `UserActivityFlyIn.tsx:75-76`). The tag alone decides, exactly as there: a `contenteditable` region
 * or a custom control is not a field.
 */
export function isFieldFocused(document: Document): boolean {
	const tag = document.activeElement?.tagName;

	return tag !== undefined && FIELD_TAGS.has(tag);
}
